import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import Link from 'domain/entity/link';
import ReadLinksClient from 'use-case/link/read/readLinksClient';
import ReadLinksCriteria from 'use-case/link/read/readLinksCriteria';

const readLinkApiClient = (httpClient: httpClientFunction, baseUrl: string): ReadLinksClient => (criteria: ReadLinksCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.dashboardId}/links?location_id=${criteria.locationId}`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asLinks)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asLinks = (linksJson: LinkJson[]) =>
    linksJson.map((linkJson: LinkJson) => new Link(linkJson.id, linkJson.linked_url, Boolean(linkJson.active)));

export type LinkJson = {
    id: string;
    ['linked_url']: string;
    active: boolean;
};

export default readLinkApiClient;
